import { createFileRoute } from '@tanstack/react-router'
import { InvitationList } from '@/components/users'

function InvitationsPage() {
  return (
    <div className="p-6">
      <InvitationList />
    </div>
  )
}

export const Route = createFileRoute('/invitations/')({
  staticData: {
    title: 'Invitations',
    isSecured: true,
  },
  component: InvitationsPage,
})
